import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Question, QuestionAnswer } from 'src/app/interfaces/question';

@Component({
  selector: 'app-feedback-question',
  templateUrl: './feedback-question.component.html',
  styleUrls: ['./feedback-question.component.scss'],
})
export class FeedbackQuestionComponent implements OnInit {

  @Input() question: Question | undefined;
  @Input() firstNameFrom: string = '';
  @Input() firstNameTo: string = '';
  @Input() showPageButton = false;
  @Input() isLastPage = false;
  @Output() answered = new EventEmitter<QuestionAnswer>();
  @Output() backClicked = new EventEmitter<void>();
  private answeredData: QuestionAnswer | undefined;

  constructor() { }

  get isAnswered(): boolean {
    // 필수값 아니면 그냥 답변 완료된걸로 처리
    if (!this.question?.isRequired) {
      return true;
    }
    // string 답변이 있거나, option 선택의 경우 array length가 있는 경우 true
    if (this.answeredData !== undefined 
      && (this.answeredData.value 
        || (Array.isArray(this.answeredData.options) && this.answeredData.options.length > 0))) {
      return true;
    }
    return false;
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('question')) {
      this.answeredData = undefined;
    }
  }

  questionAnswered(data: QuestionAnswer): void {
    this.answeredData = data;
    if (!this.showPageButton) {
      // 버튼 클릭 없이 바로 다음 질문으로 넘어가면 radio button animation 끝나기도 전에 넘어가 버림.
      // 이를 방지하기 위한 timeout
      const emitTimeout = setTimeout(() => {
        this.answered.emit(data);
        clearTimeout(emitTimeout);
      }, 300);
    }
  }

  onClickBack(): void {
    this.backClicked.emit();
  }

  onClickNext(): void {
    if (this.isAnswered) {
      this.answered.emit(this.answeredData);
    }
  }

}
